/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_Load_ErrorInputs */

const en_admin_footer_badges_load_error = /** @type {(inputs: Admin_Footer_Badges_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load footer badges.`)
};

/**
* | output |
* | --- |
* | "Could not load footer badges." |
*
* @param {Admin_Footer_Badges_Load_ErrorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_load_error = /** @type {((inputs?: Admin_Footer_Badges_Load_ErrorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_Load_ErrorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_load_error(inputs)
});
export { admin_footer_badges_load_error as "admin.footer_badges.load_error" }